if (typeof window.syncInitialCardVariants !== 'function') {
    window.syncInitialCardVariants = function() {};
}


// Shop details page video script

document.addEventListener('DOMContentLoaded', function () {

  document.querySelectorAll('.video-wrapper').forEach(function(wrapper){

    const video = wrapper.querySelector('video');
    const button = wrapper.querySelector('.video-toggle-btn');
     if (!video || !button) return;

    button.addEventListener('click', function(e){

      e.preventDefault();
      e.stopPropagation();

      if(video.paused){
        video.play();
        button.innerHTML = '⏸';
      }else{
        video.pause();
        button.innerHTML = '▶';
      }

    });

  });

});

// End Shop details page video script



//  Membership levels
document.addEventListener('DOMContentLoaded', function () {
document.addEventListener('click', function(e) {
  const btn = e.target.closest('.dropdown-btn');

  if (!btn) return;

  const currentCard = btn.closest('.card');

  currentCard.querySelector('.dropdown-content').classList.toggle('active');
  currentCard.querySelector('.arrow-set').classList.toggle('rotate');
});


  // FAQ section
document.addEventListener('click', function(e) {
  const faqBtn = e.target.closest('.faq-question');

  if (faqBtn) {
    const faqItem = faqBtn.closest('.faq-item');

    document.querySelectorAll('.faq-item').forEach(item => {
      if (item !== faqItem) {
        item.classList.remove('active');
      }
    });

    faqItem.classList.toggle('active');
    return;
  }

  // Child FAQ
  const childBtn = e.target.closest('.faq-child-question');

  if (childBtn) {
    const faqChild = childBtn.closest('.faq-child');
    const wrapper = faqChild.closest('.faq-children');

    wrapper.querySelectorAll('.faq-child').forEach(item => {
      if (item !== faqChild) {
        item.classList.remove('active');
      }
    });

    faqChild.classList.toggle('active');
  }

});

});




function initProductCardSlider() {
    $('.product-card-slider').each(function () {
        const $slider = $(this);

        if ($slider.hasClass('slick-initialized')) {
            $slider.slick('unslick');
        }

        $slider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: true,
            prevArrow: '<button type="button" class="slick-prev"><i class="icon-arrow-left"></i></button>',
            nextArrow: '<button type="button" class="slick-next"><i class="icon-arrow-right"></i></button>'
        });
    });
}

// UPDATED CODE
function safeSyncVariants() {
    if (typeof syncInitialCardVariants === 'function') {
        syncInitialCardVariants();
    }
}

$(document).ready(function () {
    initProductCardSlider();
    safeSyncVariants();
});

$(document).on('productGridUpdated', function () {
    initProductCardSlider();
    safeSyncVariants();
});


$(document).on('click', '.product-card-slider .slick-arrow, .product-card-slider .slick-dots button', function(e) {
    e.preventDefault();
    e.stopPropagation();
});



// Look for the slider configuration inside halo-quick-search.js
$('.predictive-search-results').slick({
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
        {
            breakpoint: 1025,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 768, // Ensure mobile settings are defined and NOT set to "unslick"
            settings: {
                slidesToShow: 2, // Shows multiple columns as a slider on mobile
                slidesToScroll: 1,
                arrows: false,
                dots: true
            }
        }
    ]
});